import {Controller} from "@hotwired/stimulus"
import Colcade from "colcade";
import {createEventOccurrenceElement} from "./createEventOccurrenceElement";
import {createAnnouncementElement} from "./createAnnouncementElement";
import {fetchItems} from "./fetchItems";

export default class extends Controller {

  static targets = ["grid", "sentinel"];
  declare readonly gridTarget: HTMLElement;
  declare readonly sentinelTarget: HTMLElement;
  private colcade: any | null = null;

  private currentPage = 0;
  private loading = false;
  private hasMore = true;

  private observer: IntersectionObserver | null = null;

  connect() {
    console.log('event occurrences grid connected');

    this.initializeColcade();
    this.loadMoreItems().catch(console.error);
  }

  disconnect() {
    if (this.colcade) {
      this.colcade.destroy();
    }
    if (this.observer) {
      this.observer.disconnect(); // Clean up observer
    }
  }

  initializeColcade() {
    this.colcade = new Colcade(this.gridTarget, {
      columns: '.grid-col',
      items: '.grid-item'
    });
  }

  initializeInfiniteScroll() {
    // Disconnect previous observer if it exists
    if (this.observer) {
      this.observer.disconnect();
    }

    // Set up the IntersectionObserver on the sentinel element
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
          if (entry.isIntersecting && !this.loading && this.hasMore) {
            this.loadMoreItems().catch(console.error);
          }
        },
        {
          root: null,
          rootMargin: "200px",
          threshold: 0.1
        }
      );
    });
    this.observer.observe(this.sentinelTarget);
  }

  async loadMoreItems() {
    this.loading = true;
    this.currentPage += 1;

    try {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('page', this.currentPage.toString());

      const items = await fetchItems(currentUrl.searchParams);

      if (items.length === 0) {
        this.hasMore = false;
        return;
      }

      const newGridItems = items.map((item: any) => {
        if (item.type === 'event_occurrence') {
          return createEventOccurrenceElement(item);
        } else if (item.type === 'announcement') {
          return createAnnouncementElement(item);
        }

        return null
      });

      this.colcade.append(newGridItems);
    } catch (error) {
      this.currentPage -= 1;
      console.error("Error loading more items:", error);
    } finally {
      this.loading = false;
      this.initializeInfiniteScroll();
    }
  }
}